export const MONTHS_SHORT = [
  "Ene", "Feb", "Mar", "Abr", "May", "Jun",
  "Jul", "Ago", "Sep", "Oct", "Nov", "Dic",
];

export const MONTHS_ABBR = [
  "ENE", "FEB", "MAR", "ABR", "MAY", "JUN",
  "JUL", "AGO", "SEP", "OCT", "NOV", "DIC",
];

export const MONTHS_FULL = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
];

export const PROGRAM_WEEKS = 12;
export const TOTAL_SESSIONS = 5;

// Llamada de Emergencia: reserva vía Calendly (mismos horarios que las
// llamadas de consultor). Ajustar el slug si el event type cambia en Calendly.
export const EMERGENCY_CALENDLY_URL =
  "https://calendly.com/entrena-tu-centro/sesion-de-emergencia";
